<template>
  <div>
    <div class="top_bg">
      <img src="@/assets/images/product_bg.jpg" alt="">
    </div>
    <div class="defult_title" id="indexId">
        <h1>{{language === 'E' ? 'PRODUCTS LIST' : '产品及服务'}}</h1>
        <p>{{language === 'E' ? '产品及服务' : 'PRODUCTS LIST'}}</p>
      </div>
    <div class="defult_width product-center-list">
      <el-row>
        <ul class="product-list-lable">
          <li v-for="(item,index) in product" :key="index" :class="productIndex == index ? 'news-active' : ''" @mousemove="productIndex = index">{{ item.label }}</li>
        </ul>
        <el-row class="product-box">
          <ul>
            <li v-for="item in product[productIndex].list" :key="item.name" class="list">
              <router-link :to="`productDetail/${item.id}/${product[productIndex].type}`">
                <img :src="item.img" :alt="item.title">
                <h5>
                {{ item.title }}
                </h5>
              </router-link>
            </li>
          </ul>
        </el-row>
      </el-row>
    </div>
  </div>
</template>
<script>
import productList from '@/datas/productList'
import EproductList from '@/EnglishData/productList'
export default {
  name: 'ProductCenter',
  data () {
    const language = localStorage.getItem('language')
    let languageProductList = null
    if (language && language === 'E') {
      languageProductList = EproductList
    } else {
      languageProductList = productList
    }
    const { product } = languageProductList
    return {
      product,
      productIndex: 0,
      language
    }
  },
  created () {
    this.$nextTick(() => { this.getlocal() })
  },
  methods: {
    getlocal () {
      this.productIndex = this.$route.query.type || 0
      let toElement = document.getElementById('indexId')
      if (this.$route.query.type) {
        toElement.scrollIntoView()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.product-center-list {
  .product-list-lable {
    // width: 20%;
    border: none;
    display: flex;
    justify-content: center;
    margin: 0 auto 20px;
    li {
      padding: 0 15px;
      margin: 0 15px;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
      transition: all .5s;
      border-bottom: 1px solid #fff;
      position: relative;
      &:hover {
        border-color: #1e50ae;
        color: #1e50ae;
      }
      &::after {
        width: 1px;
        height: 24px;
        content: ' ';
        position: absolute;
        right: -15px;
        top: 13px;
        display: block;
        background: #e5e5e5;
      }
      &:last-child {
        &::after {
          display: none;
        }
      }
    }
    .news-active {
      border-color: #1e50ae;
      color: #1e50ae;
    }
  }
  .product-box {
    margin: 50px 0;
    ul {
      width: 100%;
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      .list {
        width: 21%;
        margin: 0 2% 40px;
        a {
          display: block;
          border: 1px solid #f0f0f0;
          padding: 40px 20px;
          img {
            width: 80px;
            height: 80px;
          }
          h5 {
            padding-top: 20px;
            font-size: 16px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/view/product/ProductCenter.vue